import { EventTypes } from 'starting-blocks'

export default class Nav {
  constructor() {
    this.containers = [...document.querySelectorAll('.js-nav')]
  }

  init() {
    this.initStaticEvents()
    this.initDynamicEvents()
  }

  initStaticEvents() {
    window.addEventListener(EventTypes.TRANSITION_COMPLETE, this.onTransitionComplete.bind(this))
  }

  initDynamicEvents() {}

  onTransitionComplete() {
    this.containers.forEach((container) => {
      console.log('nav')
    })
  }
}
